export const restaurantData = {
  id: 'bulvar-pide-kebap',
  name: 'Bulvar Pide & Kebap',
  description: 'Soğanlı, Bursa',
  categories: [
    {
      id: 'pides',
      name: 'Fırın Ürünleri',
      icon: '🥖',
      items: [
        {
          id: 'lahmacun',
          name: 'Lahmacun',
          description: 'Dana Etinden Çıtır  Lahmacun',
          price: 75,
          image: '/images/lahmacun.jpg',
          category: 'lahmacun'
        },
        // Cantıklar
        {
          id: 'kiymali-cantik',
          name: 'Kıymalı Cantık',
          description: 'Dana Kıymadan Kıymalı Cantık ',
          price: 65,
          image: '/images/kiymali-cantik.JPG',
          category: 'cantik'
        },
        {
          id: 'kusbasi-cantik',
          name: 'Kuşbaşılı Cantık',
          description: 'Dana Kuşbaşından Cantık',
          price: 75,
          image: '/images/kusbasi-cantik.jpg',
          category: 'cantik'
        },
        {
          id: 'kasarli-cantik',
          name: 'Kaşarlı Cantık',
          description: 'Taze Kaşar Peynirinden Cantık',
          price: 75,
          isVegetarian: true,
          image: '/images/kasarlicantik.jpg',
          category: 'cantik'
        },
        {
          id: 'kiymali-kasarli-cantik',
          name: 'Kıymalı Kaşarlı Cantık',
          description: 'Dana Kıyma ve Taze Kaşar Peynirinden Cantık',
          price: 80,
          image: '/images/kiymali-kasarli-cantik.jpg',
          category: 'cantik'
        },
        {
          id: 'kusbasi-kasarli-cantik',
          name: 'Kuşbaşılı Kaşarlı Cantık',
          description: 'Dana Kuşbaşı ve Taze Kaşar Peynirinden Cantık',
          price: 85,
          image: '/images/kusbasi-kasarli-cantik.jpg',
          category: 'cantik'
        },
        {
          id: 'karisik-cantik',
          name: 'Karışık Cantık',
          description: 'Dana Kuşbaşı, Kıyma ve Kaşar Peynirinden Cantık',
          price: 85,
          image: '/images/karisik-cantik.jpg',
          category: 'cantik'
        },
        {
          id: 'sucuklu-kasarli-cantik',
          name: 'Sucuklu Kaşarlı Cantık',
          description: 'Dana Sucuk ve Taze Kaşar Peynirinden Cantık',
          price: 85,
          image: '/images/sucuklu-cantık.jpg',
          category: 'cantik'
        },
        // Pideler
        {
          id: 'kiymali-pide',
          name: 'Kıymalı Pide',
          description: 'Dana Kıymadan Kıymalı Pide',
          price: 180,
          image: '/images/kiymalipide.jpg',
          category: 'pide'
        },
        {
          id: 'kusbasi-pide',
          name: 'Kuşbaşılı Pide',
          description: 'Dana Kuşbaşından Pide',
          price: 190,
          image: '/images/kusbasili-pide.JPG',
          category: 'pide'
        },
        
        {
          id: 'kasarli-pide',
          name: 'Kaşarlı Pide',
          description: 'Taze Kaşar Peynirinden Kaşarlı Pide',
          price: 190,
          isVegetarian: true,
          image: '/images/kasarli-pide.JPG',
          category: 'pide'
        },
        {
          id: 'kiymali-kasarli-pide',
          name: 'Kıymalı Kaşarlı Pide',
          description: 'Dana Kıyma ve Kaşar Peynirinden Pide',
          price: 200,
          image: '/images/kiymali-kasarli-pide.jpg',
          category: 'pide'
        },
        {
          id: 'kusbasi-kasarli-pide',
          name: 'Kuşbaşılı Kaşarlı Pide',
          description: 'Dana Kuşbaşı ve Kaşar Peynirinden Pide',
          price: 210,
          image: '/images/kusbasi-kasarli-pide.JPG',
          category: 'pide'
        },
        {
          id: 'karisik-pide',
          name: 'Karışık Pide',
          description: 'Dana Kıyma, Kuşbaşı ve Kaşardan Pide',
          price: 210,
          image: '/images/kusbasi-kasarli-pide.JPG',
          category: 'pide'
        },
        {
          id: 'sucuklu-kasarli-pide',
          name: 'Sucuklu Kaşarlı Pide',
          description: 'Dana Sucuk ve Kaşar Peynirinden Pide',
          price: 210,
          image: '/images/sucuklupide.jpg',
          category: 'pide'
        }
      ]
    },
    {
      id: 'kebabs',
      name: 'Kebaplar & Izgaralar',
      description: 'Mangal ateşinde pişen lezzetler',
      icon: '🍖',
      items: [
        {
          id: 'ciger',
          name: 'Ciğer Şiş',
          description: 'Köz Ateşinde Izgara Ciğer',
          price: 400,
          image: '/images/ciger.jpg'
        },
        {
          id: 'adana-kebap',
          name: 'Adana Kebap',
          description: 'Köz Ateşinde Dana Etinden Acılı Kıyma Kebap',
          price: 300,
          isSpicy: true,
          image: '/images/adana.JPG'
        },
        {
          id: 'urfa-kebap',
          name: 'Urfa Kebap',
          description: 'Köz Ateşinde Dana Etinden Acısız Kıyma Kebap',
          price: 300,
          image: '/images/urfa.JPG'
        },
        {
          id: 'tavuk-kanat',
          name: 'Tavuk Kanat',
          description: 'Köz Ateşinde Özel Soslu Tavuk Kanat',
          price: 300,
          image: '/images/kanat.JPG'
        },
        {
          id: 'tavuk-sis',
          name: 'Tavuk Şiş',
          description: 'Köz Ateşinde Özel Soslu İncik Tavuk Şiş',
          price: 300,
          image: '/images/tavuk-sis.jpg'
        },
        {
          id: 'sarma-beyti',
          name: 'Beyti Sarma',
          description: 'Lavaş Arasına Sarılmış Soslu Tereyağlı Kebap',
          price: 360,
          image: '/images/beyti-sarma.JPG'
        },
        {
          id: 'yogurtlu-kebap',
          name: 'Yoğurtlu Kebap',
          description: 'Tırnak Pide Sos ve Tereyağı Eşliğinde Kebap',
          price: 360,
          image: '/images/Yogurtlu-Kebap.jpg'
        },
        {
          id: 'domatesli-kebap',
          name: 'Domatesli Kebap',
          description: 'Domatesli kebap',
          price: 500,
          image: '/images/domatesli kebap.jpeg'
        },
        {
          id: 'patlicanli-kebap',
          name: 'Patlıcanlı Kebap',
          description: 'Patlıcanlı  Kebap',
          price: 500,
          image: '/images/patlıcanlı-kebap.JPG'
        },
        {
          id: 'karisik-kebap',
          name: 'Karışık Kebap',
          description: 'Kebap Çeşitlerinin Bir Arada Birleştiği Kebap',
          price: 600,
          image: '/images/karisik-kebap.jpg'
        }
      ]
    },
    {
      id: 'wraps',
      name: 'Dürümler',
      description: 'Pratik ve lezzetli dürümler',
      icon: '🌯',
      items: [
        {
          id: 'ciger-durum',
          name: 'Ciğer Dürüm',
          description: 'Lavaş Arasına Izgara Ciğer',
          price: 220,
          image: '/images/ciger-durum.jpg'
        },
        {
          id: 'adana-durum',
          name: 'Adana Dürüm',
          description: 'Lavaş Arasına Acılı Adana Kebap',
          price: 160,
          isSpicy: true,
          image: '/images/dürüm.JPG'
        },
        {
          id: 'urfa-durum',
          name: 'Urfa Dürüm',
          description: 'Lavaş Arasına Acısız Urfa Kebap',
          price: 160,
          image: '/images/dürüm.JPG'
        },
        {
          id: 'tavuk-sis-durum',
          name: 'Tavuk Şiş Dürüm',
          description: 'Lavaş Arasında Tavuk Şiş',
          price: 160,
          image: '/images/tavuk-sis-dürüm.png'
        }
      ]
    },
    {
      id: 'sides',
      name: 'Yan Ürünler',
      description: 'Ana yemeklerin yanında',
      icon: '🥗',
      items: [
        {
          id: 'corba',
          name: 'Ezogelin Çorbası',
          description: 'Günlük Taze Hazırlanan Çorba',
          price: 100,
          isVegetarian: true,
          image: '/images/corba.jpg'
        },
        {
          id: 'acili-ezme',
          name: 'Ezme',
          description: 'Çeşitli Sebze ve Baharatlarla Hazırlanan Ezme',
          price: 100,
          isVegetarian: true,
          isVegan: true,
          isSpicy: true,
          image: '/images/ezme.jpg'
        },
        {
          id: 'coban-salatasi',
          name: 'Çoban Salatası',
          description: 'Domates Salatalık Soğan Salatası',
          price: 100,
          isVegetarian: true,
          isVegan: true,
          image: '/images/coban-salata.jpg?v=2024'
        }
      ]
    },
    {
      id: 'desserts',
      name: 'Tatlılar',
      description: 'Tatlı son',
      icon: '🍰',
      items: [
        {
          id: 'kunefe',
          name: 'Künefe',
          description: 'Peynir ve Kadayıfla Hazırlanan Sıcak Tatlı',
          price: 150,
          isVegetarian: true,
          image: '/images/Kunefe.jpg'
        }
      ]
    },
    {
      id: 'beverages',
      name: 'İçecekler',
      description: 'Serinletici içecekler',
      icon: '🥤',
      items: [
        {
          id: 'coca-cola',
          name: 'Kola',
          description: 'Gazlı İçecek',
          price: 50,
          isVegetarian: true,
          isVegan: true,
          image: '/images/kola.png'
        },
        {
          id: 'fanta',
          name: 'Fanta',
          description: 'Portakallı Gazlı İçecek',
          price: 50,
          isVegetarian: true,
          isVegan: true,
          image: '/images/fanta.png'
        },
        {
          id: 'gazoz',
          name: 'Gazoz',
          description: 'Ferahlatıcı gazoz',
          price: 50,
          isVegetarian: true,
          isVegan: true,
          image: '/images/gazoz.png'
        },
        {
          id: 'cappy',
          name: 'Meyve Suyu',
          description: 'Meyve Suyu',
          price: 60,
          isVegetarian: true,
          isVegan: true,
          image: '/images/meyve-suyu.png'
        },
        {
          id: 'sira',
          name: 'Şıra',
          description: 'Geleneksel Şıra',
          price: 70,
          isVegetarian: true,
          isVegan: true,
          image: '/images/sira.png'
        },
        {
          id: 'salgam',
          name: 'Şalgam Suyu ',
          description: 'Acılı ve Acısız Şalgam Suyu',
          price: 40,
          isVegetarian: true,
          isVegan: true,
          isSpicy: true,
          image: '/images/salgam.png'
        },
        {
          id: 'ayran',
          name: 'Ayran',
          description: 'Yoğurt İçeceği',
          price: 25,
          isVegetarian: true,
          image: '/images/backup_ayran.png'
        },
        {
          id: 'soda',
          name: 'Soda',
          description: 'Sade Soda',
          price: 25,
          isVegetarian: true,
          isVegan: true,
          image: '/images/backup_soda.png'
        },
        {
          id: 'su',
          name: 'Su ',
          description: 'Su',
          price: 15,
          isVegetarian: true,
          isVegan: true,
          image: '/images/su.png'
        }
      ]
    }
  ]
};
